module.exports = __webpack_public_path__ + "static/media/group4122@2x.b6153dad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group4122@2x.png
// module id = 585
// module chunks = 1